module.exports = __webpack_public_path__ + "static/media/banner_with_date.207bae07.png";